import {EntityApiService, ApiClientService} from '@dofleini/security';

class NomenclaturesServicesCategoryApiService extends EntityApiService {

    search = (params) => ApiClientService.post(this.getPath('/search'), {filters: params.filters, search: params?.search, type: 'TEMPLATE'});

    getChildren = ({parentId, ...params}) => ApiClientService.post(this.getPath(`/${parentId}/children`), {...params, type: 'TEMPLATE'});
}

export default new NomenclaturesServicesCategoryApiService('/ms-core/api/categories');
